/**
 * @file form_inasistencia_sin_boton.jsx.
 * @version 1.0.0.
 * @description Formulario de inasistencia sin botón de agregar.
 * @author Componente Sistemas Ases.
 * @contact sistemas.ases@correounivalle.edu.co.
 */

import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Dropdown,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormCheck,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Update_Inasistencia from "../../service/update_inasistencia";
import Delete_inasistencia from "../../service/delete_inasistencia";
import Seguimientos_enviar_observaciones from "../../service/seguimientos_enviar_observaciones";
import Seguimientos_enviar_observaciones_inasistencia from "../../service/seguimientos_enviar_observaciones_inasistencia.js";
import { CSVLink } from "react-csv";
import {
  desencriptarInt,
  desencriptar,
  encriptar,
} from "../../modulos/utilidades_seguridad/utilidades_seguridad.jsx";

/**
 * Componente funcional que representa un formulario de inasistencia sin botón de agregar.
 * @param {Object} props - Propiedades del componente.
 * @returns {JSX.Element} Formulario de inasistencia.
 */
const Inasistencia = (props) => {
  // Constantes modal de observaciones
  const [showModalMail, setShowModalMail] = useState(false);
  const handleShowMail = () => setShowModalMail(true);
  const handleCloseMail = () => setShowModalMail(false);

  /**
   * Función para recargar la página.
   */
  const recargarPagina = () => {
    if (props.recarga_ficha_estudiante) {
      // Cambiar la URL a la página con el ID del estudiante seleccionado
      sessionStorage.setItem(
        "path",
        encriptar(`/ficha_estudiante/${form.id_estudiante}`)
      );
      window.location.reload();
    } else {
      props.updateDataUserSocioedu(form.id_estudiante);
    }
  };

  // Estado local del formulario.
  const [form, set_form] = useState({
    id: props.item.id,
    fecha: props.item.fecha,
    observaciones: props.item.observaciones,
    revisado_profesional: props.item.revisado_profesional,
    revisado_practicante: props.item.revisado_practicante,
    id_creador: props.item.id_creador,
    id_modificador: parseInt(
      desencriptarInt(sessionStorage.getItem("id_usuario"))
    ),
    id_estudiante: props.item.id_estudiante,
    observaciones_correo: "",
  });

  // Hora de creación y edición del formulario.
  const hora_creacion = new Date(props.item.creacion);
  const hora_edicion = new Date(props.item.modificacion);

  /**
   * Actualiza la información de la inasistencia.
   */
  const set_info = (e) => {
    Update_Inasistencia.Update_inasistencia(form).then((res) => {
      if (res) {
        props.handleCloseIn();
        recargarPagina();
      } else {
        window.alert(
          "Hubo un error al momento de actualizar la inasistencia, por favor verifique si los datos que ingreso son correctos y que llenó toda la información obligatoria."
        );
      }
    });
  };

  /**
   * Elimina la información de la inasistencia.
   */
  const delete_info = (e) => {
    if (window.confirm("¿Está seguro que desea eliminar la inasistencia?")) {
      Delete_inasistencia.Delete_inasistencia(form.id).then((res) => {
        if (res) {
          props.handleCloseIn();
          recargarPagina();
        } else {
          window.alert("Hubo un error al momento de eliminar la inasistencia.");
        }
      });
    }
  };

  /**
   * Maneja el cambio de los checkbox en el formulario.
   * @param {Event} e - Evento de cambio en el checkbox.
   */
  const handleFormChecks = (e) => {
    set_form({
      ...form,
      [e.target.name]: e.target.checked,
    });
  };

  /**
   * Maneja el cambio en los campos del formulario.
   * @param {Event} e - Evento de cambio en el input.
   */
  const handleForm = (e) => {
    set_form({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // Rol del usuario actual.
  const userRole = desencriptar(sessionStorage.getItem("rol"));

  /**
   * Maneja el cierre del modal.
   */
  const handleChange = () => {
    props.handleCloseIn();
    props.handleModal();
  };

  /**
   * Función para enviar las observaciones del seguimiento.
   */
  const enviar_observaciones = (e) => {
    // console.log("Boton enviar observaciones");
    // console.log(form);
    e.target.disabled = true;
    Seguimientos_enviar_observaciones_inasistencia.seguimiento_enviar_observaciones_inasistencia(
      form
    )
      .then((res) => {
        if (res) {
          //   recargarPagina();
          //   props.handleClose();
          // console.log("Observaciones enviadas");
          alert("Observaciones enviadas");
          handleCloseMail();
          // setShowModalMail(false);
        }
      })
      .catch((error) => {
        console.error(error);
        alert("Error al enviar observaciones");
      });
  };

  // Renderiza el formulario de inasistencia.
  return (
    <Modal {...props} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Inasistencia</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h1>
          <b>Inasistencia</b>
        </h1>
        <hr></hr>
        <Row>
          <Col>
            <Row className="g-2">
              <h6>Fecha*:</h6>
            </Row>
            <Row className="g-2">
              <Form.Control
                type="date"
                defaultValue={props.item.fecha}
                name="fecha"
                onChange={handleForm}
              />
            </Row>
          </Col>
        </Row>
        <br />
        <Row className="g-2">
          <h6>Observaciones*:</h6>
        </Row>
        <Row className="g-2">
          <Form.Control
            as="textarea"
            rows={3}
            defaultValue={props.item.observaciones}
            name="observaciones"
            onChange={handleForm}
          />
        </Row>
        <br />
        <Row>
          <Col>
            <Form.Check
              type="checkbox"
              label="Revisado profesional"
              defaultChecked={props.item.revisado_profesional}
              disabled={
                !(userRole === "profesional" || userRole === "super_ases")
              }
              name="revisado_profesional"
              onChange={handleFormChecks}
            />
          </Col>
          <Col>
            <Form.Check
              type="checkbox"
              label="Revisado practicante"
              defaultChecked={props.item.revisado_practicante}
              disabled={
                !(
                  userRole === "practicante" ||
                  userRole === "profesional" ||
                  userRole === "super_ases"
                )
              }
              name="revisado_practicante"
              onChange={handleFormChecks}
            />
          </Col>
        </Row>
        <hr></hr>
        <Row className="g-2">
          <h6>
            <b>Creación: </b> fecha: {hora_creacion.toLocaleDateString()} hora:{" "}
            {hora_creacion.toLocaleTimeString()}{" "}
          </h6>
        </Row>
        <Row className="g-2">
          <h6>
            <b>Última modificación: </b>fecha:{" "}
            {hora_edicion.toLocaleDateString()} hora:{" "}
            {hora_edicion.toLocaleTimeString()}{" "}
          </h6>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <CSVLink
          data={[props.item]}
          filename={"Inasistencia Individual " + props.item.fecha}
        >
          <Button variant="link">Descargar CSV</Button>
        </CSVLink>
        {!(
          props.item.revisado_profesional === true &&
          !(userRole === "profesional" || userRole === "super_ases")
        ) ? (
          <>
            <Button variant="secondary" onClick={handleShowMail}>
              Enviar observaciones
            </Button>
            <>
              <Modal
                show={showModalMail}
                onHide={handleCloseMail}
                size="md"
                backdrop="static"
                className="observation-modal"
              >
                <Modal.Header closeButton>
                  <Modal.Title>Envío de observaciones</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row className="g-2">
                    <h6>Observaciones:</h6>
                  </Row>
                  <Row className="g-2">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      defaultValue={""}
                      name="observaciones_correo"
                      onChange={(e) =>
                        set_form({
                          ...form,
                          observaciones_correo: e.target.value,
                        })
                      }
                      title="Máximo 5000 caracteres."
                    />
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseMail}>
                    Cerrar
                  </Button>
                  <Button variant="primary" onClick={enviar_observaciones}>
                    Enviar
                  </Button>
                </Modal.Footer>
              </Modal>
            </>

            <Button
              variant="danger"
              onClick={() => {
                delete_info();
              }}
              disable={
                props.item.revisado_profesional ||
                props.item.revisado_practicante
              }
            >
              Eliminar
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                set_info();
              }}
              disable={
                props.item.revisado_profesional ||
                props.item.revisado_practicante
              }
            >
              Aceptar cambios
            </Button>
          </>
        ) : null}
        <Button
          variant="secondary"
          onClick={() => {
            props.handleCloseIn();
          }}
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Inasistencia;
